export default __webpack_public_path__ + "static/media/citibank.4ec69a77.svg";